import axios from "axios";
// import {toast} from "vue3-toastify";

const apiUrl = process.env.VUE_APP_API_URL;

/**
 * دریافت اطلاعات پروفایل کاربر
 * @returns {Promise<Object>} پروفایل کاربر
 */
export const getProfile = async () => {
    try {
        const response = await axios.get(`${apiUrl}/user`);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
        // toast.error('خطا در دریافت اطلاعات');
        // console.error("Error fetching profile:", error);
        // //throw error;
    }
};

/**
 * بروزرسانی اطلاعات پروفایل کاربر
 * @param {Object} data داده‌های جدید پروفایل
 * @returns {Promise<Object>} پروفایل آپدیت شده
 */
export const updateProfile = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/user/complete-profile`, data);
        return response.data; // پروفایل آپدیت شده
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
        // throw error;
    }
};
